import moment from 'moment';
import {toast} from 'react-toastify';

/**
 * Dividend payloads carry `instrumentId` and nothing else that identifies the
 * asset.
 *
 * The investing service resolves the issuer company, instrument key and asset
 * class from the instrument itself, and rejects `companyId`,
 * `investmentCategory`, `assetClassKey` and `instrumentKey` on sight — merely
 * *sending* one of those keys fails the whole call ("no longer accepts
 * companyId, investmentCategory. Use instrumentId"). So they are never spread
 * into a payload, not even as null.
 */

export const handleDefaultPayout = (
  values,
  getInvestedUsersByDateRange,
  dispatch,
  handleUpdateDividendId,
  onClose,
  form,
) => {
  const {
    assetCurrency,
    startDate,
    endDate,
    amountPerShare,
    instrumentId,
    principalPerShare,
    taxName,
    taxPercentage,
  } = values;

  getInvestedUsersByDateRange({
    variables: {
      input: {
        assetCurrency,
        instrumentId,
        taxName,
        ...(taxPercentage && {taxPercentage: Number(taxPercentage)}),
        ...(principalPerShare && {
          principalPerShare: Number(principalPerShare),
        }),
        ...(startDate && {startDate: moment(startDate).format()}),
        ...(endDate && {endDate: moment(endDate).format()}),
        amountPerShare: Number(amountPerShare),
      },
    },
    onError: error => toast.error(`Error something wrong -${error.message}`),
  })
    .then(({data: {getInvestedUsersByDateRange}}) => {
      if (getInvestedUsersByDateRange.__typename === 'Error') {
        toast.error(getInvestedUsersByDateRange.message);
      } else {
        dispatch(handleUpdateDividendId({instrumentId}));
        toast.success(getInvestedUsersByDateRange?.message);
        form.resetFields();
        onClose();
      }
    })
    .catch(error => toast.error(error));
};

export const handleCSVPayoutUpload = (
  values,
  csvUrl,
  setCSVUrl,
  bulkUploadDividendPayout,
  dispatch,
  handleUpdateDividendId,
  onClose,
  form,
) => {
  const {
    assetCurrency,
    startDate,
    endDate,
    taxName,
    taxPercentage,
    instrumentId,
  } = values;
  if (!csvUrl) return toast.error('CSV File Required');

  return bulkUploadDividendPayout({
    variables: {
      input: {
        assetCurrency,
        instrumentId,
        url: csvUrl,
        taxName,
        ...(taxPercentage && {taxPercentage: Number(taxPercentage)}),
        ...(startDate && {
          startDate: moment(startDate).format(),
        }),
        ...(endDate && {endDate: moment(endDate).format()}),
      },
    },
  })
    .then(({data: {bulkUploadDividendPayout}}) => {
      if (bulkUploadDividendPayout.__typename === 'Error') {
        toast.error(bulkUploadDividendPayout.message);
      } else {
        dispatch(handleUpdateDividendId({instrumentId}));
        toast.success(bulkUploadDividendPayout?.message);
        onClose();
        setCSVUrl(null);
        form.resetFields();
      }
    })
    .catch(error => toast.error(error));
};

export const handleSingleUser = (
  values,
  addDividendPayout,
  dispatch,
  onClose,
  handleUpdateDividendId,
  user,
  form,
) => {
  const {
    assetCurrency,
    startDate,
    endDate,
    instrumentId,
    principalPerShare,
    amountPerShare,
    units,
    taxName,
    taxPercentage,
  } = values;
  if (!user) return toast.error('Please select a user');

  return addDividendPayout({
    variables: {
      input: {
        assetCurrency,
        units: Number(units),
        instrumentId,
        ...(principalPerShare && {
          principalPerShare: Number(principalPerShare),
        }),
        taxName,
        ...(taxPercentage && {taxPercentage: Number(taxPercentage)}),
        userId: user.split(';')[2],
        amountPerShare: Number(amountPerShare),
        ...(startDate && {
          startDate: moment(startDate).format(),
        }),
        ...(endDate && {endDate: moment(endDate).format()}),
      },
    },
  })
    .then(({data: {addDividendPayout}}) => {
      if (addDividendPayout.__typename === 'Error') {
        toast.error(addDividendPayout.message);
      } else {
        dispatch(handleUpdateDividendId({instrumentId}));
        toast.success(addDividendPayout?.message);
        onClose();
        form.resetFields();
      }
    })
    .catch(error => toast.error(error));
};

export const handleProcessCSVPayout = (
  values,
  generateAndExportInvestedUsers,
  onClose,
  form,
) => {
  const {assetCurrency, startDate, endDate, instrumentId} = values;

  generateAndExportInvestedUsers({
    variables: {
      filter: {
        assetCurrency,
        instrumentId,
        ...(startDate && {startDate: moment(startDate).format()}),
        ...(endDate && {endDate: moment(endDate).format()}),
      },
    },
    onError: error => toast.error(`Error something wrong -${error.message}`),
  })
    .then(({data: {generateAndExportInvestedUsers}}) => {
      if (generateAndExportInvestedUsers.__typename === 'Error') {
        toast.error(generateAndExportInvestedUsers.message);
      } else {
        toast.success(generateAndExportInvestedUsers?.message);
        form.resetFields();
        onClose();
      }
    })
    .catch(error => toast.error(error));
};
